import React from "react";

/** Small bordered square holding a number, next to a tab label. */
const Counter = ({ value = 0, className = "" }) => (
    <span
        className={`inline-flex h-5 min-w-[20px] shrink-0 items-center justify-center rounded border border-gray-200 bg-white px-1 text-xs font-medium leading-4 text-gray-700 ${className}`}
    >
        {value}
    </span>
);

export default Counter;
